<template>
    <div class="currency-container">
        <div class="currency-header">
            <span class="currency-add">Type</span>
            <v-tooltip bottom>
                <v-btn flat color="black" slot="activator" @click="addFacilityTypeItem" class="item-add-button-icon">
                    <v-icon large color="indigo">mdi-plus</v-icon>
                </v-btn>
                <div>Add new type</div>
            </v-tooltip>
        </div>
        <div>
            <AppTable :data="facilityTypesData" :owner="'type'" :saving="saving"
                @deleteItem="deleteFacilityTypeItem" @saveItem="saveFacilityType" @cancelEdit="cancelEditFacilityTypeItem"
                @editItem="editFacilityTypeItem" class="currency-table" />
        </div>
     </div>
</template>
<script>
    import { mapGetters, mapActions } from 'vuex';

    import AppTable from '@/components/common/AppTable';

    export default {
        name: 'facility-type-settings',
        components: {
            AppTable
        },
        data() {
            return {
                saving: false
            };
        },
        computed: {
            ...mapGetters({ facilityTypes: 'getFacilityTypes' }),
            facilityTypesData() {
                return {
                    items: [
                        ...this.facilityTypes
                    ]
                };
            }
        },
        methods: {
            ...mapActions([
                'deleteFacilityType',
                'addFacilityType',
                'editFacilityType',
                'cancelFacilityTypeEdit',
                'changeFacilityType',
                'createNewFacilityType'
            ]),
            deleteFacilityTypeItem(index) {
                this.deleteFacilityType(index);
            },
            addFacilityTypeItem() {
                this.addFacilityType({
                    id: -1,
                    name: '',
                    editting: true,
                    editable: true
                });
            },
            editFacilityTypeItem(facilityTypeId) {
                this.editFacilityType(facilityTypeId);
            },
            cancelEditFacilityTypeItem() {
                this.cancelFacilityTypeEdit();
            },
            saveFacilityType(payload) {
                this.saving = true;
                if (payload.id > 0) {
                    this.changeFacilityType(payload).then(() => {
                        this.saving = false;
                    });
                } else {
                    this.createNewFacilityType(payload.name).then(() => {
                        this.saving = false;
                    });
                }
            }
        }
    };
</script>
<style scoped>
.currency-container {
    padding-bottom: 26px;
}

.currency-header {
    font-size: 24px;
    padding-left: 24px;
    padding-bottom: 14px;
    margin-top: 10px;
}

.currency-table {
    margin: 0 26px;
}

.currency-add {
    margin-right: 15px;
}

@media screen and (max-width: 600px) {
    .currency-table {
        margin: 0 13px;
    }
    
    .card__text {
        padding-left: 8px;
        padding-right: 8px;
    }

    .currency-header {
        font-size: 14px;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/pages/FacilityTypeSettings.vue